<template>
  <gj-select
      v-bind="$attrs"
      v-on="$listeners"
      :options="active ? activeUserOptions : userOptions"
      :placeholder="placeholder"
  ></gj-select>
</template>

<script>
  import {mapGetters} from "vuex";
  import {
    USER_GET_ACTIVE_USER_OPTIONS,
    USER_GET_USER_OPTIONS
  } from "../../store/action-types";

  export default {
    name: "gj-creator-select",
    props: {
      active: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '创建人'
      }
    },
    computed: {
      ...mapGetters({
        userOptions: 'userOptions',
        activeUserOptions: 'activeUserOptions'
      }),
    },
    created() {
      if (this.active) {
        if (this._.isEmpty(this.activeUserOptions)) {
          this.$store.dispatch(USER_GET_ACTIVE_USER_OPTIONS);
        }
      } else {
        if (this._.isEmpty(this.userOptions)) {
          this.$store.dispatch(USER_GET_USER_OPTIONS);
        }
      }
    },
    methods: {
      getOptions() {
        let data = this.active ? this.activeUserOptions : this.userOptions;
        data = [...data]
        return data
      }
    }
  }
</script>

<style scoped>

</style>
